import {Component, Input} from '@angular/core';
import {ND} from '@pt/pt-models';
import { WidgetType } from 'it/primatoo/openapi/api/org/schemas/common/docs/WidgetType';

@Component({
  selector: 'pt-widget-version-missing',
  template: `
    <p class="text-warning">
      Widget <b>{{ label }}</b>[{{ type }}] of version [{{ version ? version : ND }}] missing
    </p>
  `
})
export class WidgetVersionMissingComponent {

  @Input() type: WidgetType;
  @Input() version: number;
  @Input() label: string;

  ND = ND;
}
